import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import GroupsIcon from '@mui/icons-material/Groups';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { containerVariants, fadeIn, lineVariants } from '../styles/animations';
import { FeatureCard } from './FeatureCard';

const features = [
  {
    icon: <GroupsIcon sx={{ fontSize: { xs: '2rem', sm: '3rem' } }} />,
    title: 'Build Your Dream Team',
    description: 'Select 8 elite fighters to create your ultimate roster',
  },
  {
    icon: <ShowChartIcon sx={{ fontSize: { xs: '2rem', sm: '3rem' } }} />,
    title: 'Earn Points',
    description:
      "Accumulate points based on your fighters' performances in real UFC events",
  },
  {
    icon: <CalendarMonthIcon sx={{ fontSize: { xs: '2rem', sm: '3rem' } }} />,
    title: 'Compete Globally',
    description:
      'Join seasonal competitions and test your team against other players',
  },
  {
    icon: <EmojiEventsIcon sx={{ fontSize: { xs: '2rem', sm: '3rem' } }} />,
    title: 'Win Tournaments',
    description:
      'Participate in special tournaments with unique rules and prizes',
  },
];

export const FeaturesSection = () => {
  return (
    <Container sx={{ paddingBottom: '50px' }}>
      <Box
        sx={{
          paddingY: '70px',
          minHeight: '100vh',
        }}
      >
        <Box
          component={motion.div}
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.2 }}
          variants={containerVariants}
          sx={{
            textAlign: 'center',
            maxWidth: '800px',
            margin: '0 auto',
            padding: '40px 20px',
            marginBottom: '60px',
          }}
        >
          <motion.div variants={fadeIn}>
            <Typography
              sx={{
                color: '#ffffff',
                fontSize: 'clamp(1rem, 1.8vw, 1.4rem)',
                lineHeight: 1.6,
                fontFamily: 'Rubik Mono One',
                marginBottom: '20px',
              }}
            >
              A First of its Kind Fantasy Experience
            </Typography>
          </motion.div>

          <motion.div variants={fadeIn} transition={{ delay: 0.1 }}>
            <Typography
              sx={{
                color: '#cccccc',
                fontSize: 'clamp(0.9rem, 1.5vw, 1.1rem)',
                lineHeight: 1.8,
                fontFamily: 'Arial',
              }}
            >
              Immerse yourself in the electrifying world of UFC with our
              revolutionary fantasy platform. Experience the thrill of each
              fight as your carefully selected fighters compete in real-time,
              bringing a new dimension to how you enjoy mixed martial arts.
            </Typography>
          </motion.div>
        </Box>

        <Box
          component={motion.div}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3 }}
          sx={{
            position: 'relative',
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: '1fr 1fr',
              md: '1fr 1fr 1fr 1fr',
            },
            gap: { xs: '20px', sm: '30px' },
            padding: { xs: '30px 0', sm: '50px 0' },
            marginTop: { xs: '10px', sm: '20px' },
          }}
        >
          <Box
            component={motion.div}
            variants={lineVariants}
            sx={{
              position: 'absolute',
              top: '50%',
              left: 0,
              height: '2px',
              background:
                'linear-gradient(90deg, transparent, #cc0000, transparent)',
              zIndex: 0,
            }}
          />

          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </Box>
      </Box>
    </Container>
  );
};
